import Vue from 'vue'
import prepareQueryParamsMixin from '../../mixins/prepareQueryParamsMixin'
import prepareFetchParamsMixin from '../../mixins/prepareFetchParamsMixin'
import OtpInput from '@bachdgvn/vue-otp-input'
import { showErrorToast, showSuccessToast } from '../../services/UI'
import JobService from '../../services/jobService'
import UserService from '../../services/UserService'
Vue.component('v-otp-input', OtpInput)
export default {
  name: 'earningsModal',
  mixins: [prepareQueryParamsMixin, prepareFetchParamsMixin],
  data () {
    return {
      mutableActived: this.activated,
      isHidden: false,
      toggle: false,
      selected: '',
      comment: ''
    }
  },
  props: ['jobId', 'jobDate', 'department', 'userName', 'professionalId', 'activated', 'closeEarningsModal'],
  methods: {
    handleFileChange (e) {
      this.$emit('input', e.target.files[0])
    },
    close () {
      console.log('actived:', this.activated)
      this.closeEarningsModal(true)
      this.mutableActived = !this.mutableActived
      this.$el.blur()
      this.selected = ''
      this.comment = ''
      console.log('yoooo', this.activated)
    },
    // async onChange (e) {
    //   console.log(e.target.value, this.selected)
    // },
    async cancelApplication () {
      if (this.selected === '') {
        return showErrorToast(this, 'Please select a reason')
      }
      if (this.comment === '') {
        return showErrorToast(this, 'Please add comment')
      }
      const res = await JobService.cancelMiniJobApplication(this.applicationId, this.selected, this.comment)
      if (res) {
        showSuccessToast(this, 'Job rejected Successfully')
      } else {
        showErrorToast(this, 'Error rejecting Job')
      }
      this.close()
    },
    async sendMailToAdmin () {
      if (this.selected === '') {
        return showErrorToast(this, 'Please select a reason')
      }
      if (this.comment === '') {
        return showErrorToast(this, 'Please add comment')
      }
      const reason = this.selected
      const description = this.comment
      const jobId = this.jobId
      const jobDate = this.jobDate
      const department = this.department
      const professionalName = this.userName
      const professionalId = this.professionalId
      // console.log('or bhai:', jobId, jobDate, department, professionalName, professionalId)
      const res = await UserService.raiseAQueryMail(reason, description, jobId, jobDate, department, professionalName, professionalId)
      if (res) {
        showSuccessToast(this, 'email has been sent to admin')
        this.close()
      } else {
        this.close()
      }
    }
  },
  watch: {
    activated (oldVal, newVal) {
      if (oldVal !== newVal && oldVal !== null) {
        this.mutableActived = !this.mutableActived
        this.$el.tabIndex = 1
        this.$nextTick(function () {
          this.$el.focus()
        })
      }
      // console.log(this.applicationId)
    }
  }
}
